<template>
  <b-container fluid style="max-width:1200px;margin-bottom: 5em;">
    <!-- Header -->
    <b-row size="lg" style="margin-top: 6em">
      <b-col cols="12" sm="12" md="2">
        <ulu-logo :brand="synatecOrder.brand" />
      </b-col>
      <b-col>
        <h2 class="text-secondary">
          {{ "Sinatec order no." }}:
          <i>{{ synatecOrder.sinatec_order_no || "/" }}</i>
        </h2>
        <h6 class="text-secondary">
          <i>{{ $t("globals.created") }}: {{ synatecOrder.created_at.substring(0, 10) }}</i>
        </h6>
      </b-col>
      <!-- Actions -->
      <b-col>
        <b-btn
          v-if="!edit && getUserBrandPermissions.synatec_order_request && synatecOrder.status === 'created'"
          class="float-right m-1"
          size="sm"
          variant="success"
          @click="requestSynatecOrder"
        >
          {{ $t("globals.request") }}
        </b-btn>
        <b-btn
          v-if="synatecOrder.status === 'created' && !edit && getUserBrandPermissions.synatec_order_edit"
          class="float-right m-1"
          size="sm"
          variant="info"
          @click="edit = true"
        >
          {{ $t("globals.edit") }}
        </b-btn>
        <b-btn
          v-if="synatecOrder.status === 'created' && !edit"
          class="float-right m-1"
          size="sm"
          variant="danger"
          @click="destroySynatecOrder"
        >
          {{ $t("globals.delete") }}
        </b-btn>
        <b-btn
          v-if="edit"
          class="float-right m-1"
          size="sm"
          variant="success"
          @click="saveChanges"
        >
          {{ $t("globals.save") }}
        </b-btn>
        <b-btn
          v-if="edit"
          class="float-right m-1"
          size="sm"
          variant="warning"
          @click="cancelChanges"
        >
          {{ $t("globals.cancel") }}
        </b-btn>
      </b-col>
    </b-row>
    <hr>
    <!-- Data -->
    <b-row class='mt-1'>
      <b-col cols="12" md="6">
        <b-card bg-variant="light" style="min-height: 180px" class="m-1">
          <b-row>
            <b-col>
              <h6 style="margin-top: 4px" class="text-info">
                {{ $t("globals.agent") }}:
              </h6>
            </b-col>
            <b-col>
              <b-form-input
                :placeholder="synatecOrder.agent.full_name"
                size="sm"
                disabled
              />
            </b-col>
          </b-row>
          <b-row class='mt-1'>
            <b-col>
              <h6 style="margin-top: 4px" class="text-info">
                {{ $t("globals.status") }}:
              </h6>
            </b-col>
            <b-col>
              <b-form-input :placeholder="synatecOrder.status" size="sm" disabled />
            </b-col>
          </b-row>
          <b-row class='mt-1'>
            <b-col>
              <h6 style="margin-top: 4px" class="text-info">
                {{ $t("globals.customer") }}:
              </h6>
            </b-col>
            <b-col v-if="synatecOrder.customer">
              <router-link
                style="color:#17a2b8"
                :to="{name: 'customer', params:{ id: synatecOrder.customer.id }}"
              >
                <i><u>{{ synatecOrder.customer.company_name }}</u></i>
              </router-link>
            </b-col>
          </b-row>
          <b-row class='mt-1'>
            <b-col>
              <h6 style="margin-top: 4px" class="text-info">
                {{ $t("globals.order") }}:
              </h6>
            </b-col>
            <b-col>
              <router-link
                style="color:#17a2b8"
                :to="{name: 'order', params: { id: synatecOrder.order.id }}"
              >
                <i><u>{{ $t("globals.order_no") + ": " + synatecOrder.order.order_no }}</u></i>
              </router-link>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col cols="12" md="6">
        <b-card bg-variant="light" style="min-height: 180px" class="m-1">
          <!-- Address-->
          <b-row>
            <b-col>
              <h6 class="text-secondary">{{ $t("globals.send_to") }}</h6>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <span>{{ $t("globals.first_name") }}:</span>
              <span class="float-right">
                {{ $t("globals.last_name") }}:
              </span>
              <b-input-group>
                <b-form-input
                  size="sm" :disabled='!edit'
                  v-model="synatecOrder.shipping_first_name"
                />
                <b-form-input
                  size="sm" :disabled='!edit'
                  v-model="synatecOrder.shipping_last_name"
                />
              </b-input-group>
              <span>{{ $t("globals.address") }}:</span>
              <span class="float-right">{{ $t("globals.city") }}:</span>
              <b-input-group>
                <b-form-input
                  size="sm" :disabled='!edit'
                  v-model="synatecOrder.shipping_address"
                />
                <b-form-input
                  size="sm" :disabled='!edit'
                  v-model="synatecOrder.shipping_city"
                />
              </b-input-group>
            </b-col>
            <b-col>
              <span>{{ $t("globals.postal_code") }}:</span>
              <span class="float-right">
                {{ $t("globals.country") }}:
              </span>
              <b-input-group>
                <b-form-input
                  size="sm" :disabled='!edit'
                  v-model="synatecOrder.shipping_postal_code"
                />
                <b-form-input
                  v-model="synatecOrder.shipping_country"
                  :disabled='!edit' size="sm"
                />
              </b-input-group>
              <span>{{ $t("globals.email") }}:</span>
              <b-form-input
                size="sm" :disabled='!edit'
                v-model="synatecOrder.shipping_email"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <!-- Tabs -->
    <b-row class='mt-1'>
      <b-col>
        <b-row>
          <b-col>
            <b-card bg-variant="light" class="m-1">
              <b-table
                bordered small
                :items='synatecOrder.synatec_order_items'
                :fields='fields'
                caption-top
              >
                <template #table-caption>{{ $t("globals.items") }}</template>
              </b-table>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-if="synatecOrder.imeisTable.length > 0">
          <b-col>
            <b-card bg-variant="light" class="m-1">
              <b-table
                bordered small
                :items='synatecOrder.imeisTable'
                caption-top
              >
                <template #table-caption>{{ "Imeis" }}</template>
              </b-table>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
      <b-col>
        <!-- Audits -->
        <b-row>
          <b-col>
            <b-card bg-variant="light" class="m-1">
              <b-table
                bordered small
                :items='synatecOrder.audits'
                :fields='auditsFields'
                caption-top
              >
                <template #table-caption>{{ $t("globals.audits") }}</template>
              </b-table>
            </b-card>
          </b-col>
        </b-row>
        <!-- Notes -->
        <b-row class='mt-1'>
          <b-col>
            <b-card bg-variant="light" class="m-1">
              <label class='text-secondary'>{{ $t("globals.notes") }} </label>
              <b-form-textarea v-model="synatecOrder.notes" rows="4" :disabled='!edit'>
              </b-form-textarea>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";

export default {
  components: {
    "ulu-logo": () => import("@/components/common/Logo.vue"),
  },
  data() {
    return {
      edit: false,
      loading: false,
      synatecOrder: {},
      fields: [
        'synatec_code',
        {
          key: "name",
          label: this.$t("globals.name")
        },
        {
          key: "quantity",
          label: this.$t("globals.quantity")
        },
      ],
      auditsFields: [
        {
          key: "agent.full_name",
          label: this.$t("globals.agent")
        },
        {
          key: "action",
          label: this.$t("globals.action")
        },
        {
          key: "created_at",
          label: this.$t("globals.created_at")
        }
      ]
    };
  },
  methods: {
    ...mapMutations(["setShowLoadingModal"]),
    ...mapActions("axios_mod", ["simpleFetch", "simpleMutation"]),
    refresh() {
      this.fetchSynatecOrder();
    },
    fetchSynatecOrder() {
      const data = {
        query: `
          query {
            synatecOrder (id: ${this.$route.params.id}) {
              id
              status
              agent {
                full_name
              }
              order {
                id
                order_no
              }
              customer {
                id
                company_name
              }
              imeis
              sinatec_order_no
              synatec_order_items {
                id
                name
                synatec_code
                quantity
                created_at
                updated_at
              }
              brand
              notes
              shipping_first_name
              shipping_last_name
              shipping_email
              shipping_address
              shipping_city
              shipping_postal_code
              shipping_country
              created_at
              updated_at
              audits {
                id
                agent {
                  full_name
                }
                action
                created_at
                data
              }
            }
          }
        `
      };

      this.setShowLoadingModal(true);
      this.simpleFetch({ data, this_ref: this })
        .then(res => {
          if (res) {
            this.synatecOrder = res.synatecOrder;
            this.synatecOrder.imeisTable = res.synatecOrder.imeis.map(imei => {
              return { imei: imei };
            });
          }
        })
        .finally(() => {
          this.setShowLoadingModal(false);
        });
    },
    saveChanges() {
      let variables = {
        synatec_order: {
          id: parseInt(this.$route.params.id),
          notes: this.synatecOrder.notes,
          shipping_first_name: this.synatecOrder.shipping_first_name,
          shipping_last_name: this.synatecOrder.shipping_last_name,
          shipping_email: this.synatecOrder.shipping_email,
          shipping_address: this.synatecOrder.shipping_address,
          shipping_city: this.synatecOrder.shipping_city,
          shipping_postal_code: this.synatecOrder.shipping_postal_code,
          shipping_country: this.synatecOrder.shipping_country
        }
      }

      let data = {
        query: `
          mutation SynatecOrderUpdate ($synatec_order: SynatecOrderInput) {
            res: SynatecOrderUpdate (synatec_order: $synatec_order)
          }
        `,
        variables
      };

      this.simpleMutation({ data, this_ref: this }).then(() => {
        this.edit = false;
        this.fetchSynatecOrder();
      });
    },
    destroySynatecOrder() {
      let data = {
        query: `
          mutation SynatecOrderDestroy ($synatec_order: SynatecOrderInput) {
            res: SynatecOrderDestroy (synatec_order: $synatec_order)
          }
        `,
        variables: {
          synatec_order: {
            id: parseInt(this.$route.params.id),
          }
        }
      };

      this.setShowLoadingModal(true);
      this.simpleMutation({ data, this_ref: this }).then(() => {
        this.setShowLoadingModal(false);
        this.$router.push({ name: 'allsynatecorders'});
      });
    },
    requestSynatecOrder() {
      let data = {
        query: `
          mutation SynatecOrderRequest ($synatec_order: SynatecOrderInput) {
            res: SynatecOrderRequest (synatec_order: $synatec_order)
          }
        `,
        variables: {
          synatec_order: {
            id: parseInt(this.$route.params.id)
          }
        }
      };

      this.setShowLoadingModal(true);
      this.simpleMutation({ data, this_ref: this }).then(() => {
        this.setShowLoadingModal(false);
        this.refresh();
      });
    },
    cancelChanges() {
      this.edit = false;
      this.fetchSynatecOrder();
    }
  },
  computed: {
    ...mapGetters(["getUserBrandPermissions"])
  },
  created() {
    this.fetchSynatecOrder();
  }
};
</script>
